import { render, staticRenderFns } from "./PeopleAlsoViewed.vue?vue&type=template&id=1b1fa9f0&scoped=true&"
import script from "./PeopleAlsoViewed.vue?vue&type=script&lang=js&"
export * from "./PeopleAlsoViewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1fa9f0",
  null
  
)

export default component.exports